<template>
  <div class="app">
    <my-header />
    <router-view v-slot="{ Component }">
      <transition name="fade">
        <component :is="Component"></component>
      </transition>
    </router-view>
  </div>
</template>

<script>
import MyHeader from "./view/MyHeader";

export default {
  components: {
    MyHeader,
  },
};
</script>

<style lang="scss">
@media (min-width: 769px) {
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s linear;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
    transition: opacity 150ms linear;
  }
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  &.overflow {
    overflow: hidden;
  }
}

* {
  font-family: "Roboto", sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  color: $black;
  line-height: 1.7;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;

  @media (min-width: 576px) {
    max-width: 540px;
    margin-right: auto;
    margin-left: auto;
  }

  @media (min-width: 768px) {
    max-width: 720px;
  }

  @media (min-width: 992px) {
    max-width: 960px;
  }

  @media (min-width: 1200px) {
    max-width: 1140px;
  }
}
</style>